export default __webpack_public_path__ + "static/media/xrp.37deb453.svg";